import React from 'react';
import './info-label.scss';
import InfoIconBlue from 'assets/icons/info-icon-blue.svg';

interface IInfoLabel {
  text: string;
  onClick?: () => void;
}

export default function InfoLabel({ text, onClick }: IInfoLabel) {
  return (
    <div onClick={onClick} className="info-label">
      <img src={InfoIconBlue} alt="Как проверить подпись" />
      <span className="ml_6">{text}</span>
    </div>
  );
}
